import { Button } from './Button';
import './RequireAuth.css';

interface RequireAuthProps {
   openLoginModal: () => void;
}
export function RequireAuth({ openLoginModal }: RequireAuthProps) {
   return (
      <div className="flex flex-col items-center justify-center gap-4">
         <div className="flex flex-col items-center gap-1 opacity-50">
            <img
               src="/assets/icons/lock-icon-lighter.svg"
               alt=""
               width={50}
            />
            <h4 className="gray"> You need to log in to access this page.</h4>
         </div>
         <Button
            title="Login"
            type="white-big"
            onClick={openLoginModal}
         />
      </div>
   );
}
